/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';

type PropsType = {
  data: any,
  label: string,
  type: string,
  id: number
};

export const DragHandle = (): React.Element<'div'> => {
  const Component = SortableHandle((): React.Element<'div'> => {
    return (
      <div style={{ display: 'inline' }}>
        <span className='dragHandle' />
      </div>
    );
  });

  return <Component />;
};

const SortableItem = SortableElement(({ label, data, type, id }: PropsType): React.Element<'div'> => {
  const handleSort = (direction: string) => {
    if (direction === 'up') {
      if (+data.index !== 0) {
        data.onSortEnd({
          oldIndex: data.index,
          newIndex: data.index - 1
        });
      }
    }

    if (direction === 'down') {
      if (+data.index + 1 !== _.size(data.items)) {
        data.onSortEnd({
          oldIndex: data.index,
          newIndex: data.index + 1
        });
      }
    }
  };

  return (
    <div className="sortable-item">
      <div className="panel panel-default panel-ticket panel-active">
        <div className="panel-heading">
          <div className="panel-title">
            <DragHandle index={data.index} />
            <span className='panel-title-text'>{label}</span>
          </div>
          <div className="panel-actions pull-right">
            <span
              className="panel-action"
              onClick={(): void => data.handleRemoveTicket({ type, id }, data.index)}
            >
              <i className="icon icon-trash" />
            </span>

            <span
              className={`panel-action ${+data.index === 0 ? 'disabled' : ''}`}
              onClick={() => {
                handleSort('up');
              }}
            >
              <i className="icon icon-chevron-up" />
            </span>

            <span
              className={`panel-action ${+data.index === (_.size(data.items) - 1) ? 'disabled' : ''}`}
              onClick={() => {
                handleSort('down');
              }}
            >
              <i className="icon icon-chevron-down" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SortableItem;
